(function() {
  var mixin = require('../common/mixin');
  var promisify = require('../promisify');
  var win = typeof window !== 'undefined' ? window : {};
  var Promise = win.Promise || require('pinkie');
  var isWebProtocol = require('../common/web-protocol');
  var picConverter = require('../common/picConverter');

  function noop() {}

  var mtaLog = {
    env:{
      token: '5788a4a2488076d81906aa66',
      sdkVersion: '0.01'
    },
    logs: []
  };
  var isBrowser = typeof window !== 'undefined';
  var MTNB;  // declare first

  if (!isBrowser) return;  // if not in browser, return immediately
  if (isBrowser && window.MTNB)  {
    module.exports = window.MTNB;
    return;
  }

  var sentinel = function () {
    var pendingRegistrations = 0;
    var resolverFn = noop;
    var _promise = new Promise(function (resolve) { return resolverFn = resolve; });

    function tryResolve() {
        if (pendingRegistrations <= 0) setTimeout(function () { return resolverFn(true); }, 1);
    }
    return {
      increase: function () {
        pendingRegistrations++;
      },
      decrease: function () {
        pendingRegistrations--;
        if (pendingRegistrations < 0) pendingRegistrations = 0;
        tryResolve();
      },
      tryResolve: tryResolve,
      ready: function (fn) { return _promise.then(fn); }
    };
  }();

  var debug = false;
  var logEvent = require('../common/log');
  var version = require('../common/version');

  function isObject(obj) { return Object.prototype.toString.call(obj) === '[object Object]'; }
  function isFunction(obj) { return Object.prototype.toString.call(obj) === '[object Function]'; }
  function valueFn(obj) { return obj; }
  function sum(array) {
    if (!array) return 0;
    var s = 0;
    for (var i = 0; i < array.length; i++) {
      s += array[i];
    }
    return s;
  }
  function parseName(name) {
    var partials = name.split('.');
    if (partials.length === 2) partials.unshift('basic'); // default to be basic
    return {
      businessName: partials[0],
      moduleName: partials[1],
      methodName: partials[2],
    };
  }

  // send debug message
  var log = window._MTNB_LOG || function (type, message) {
    if (type == "error" && debug == true) {
      alert("Error: " + message);
    } else if (debug == true) {
      alert("Notice: " + message);
    }
  };
  var initCallback = window._MTNB_INIT_CALLBACK || noop;

  var report = function (method, msg) {
    try {
      var element = document.createElement('script');
      //http://docs.sankuai.com/doc/knb/mtnb_docs/api/#ua
      var uaArray = navigator.userAgent.split(/\s+/);
      var ualen = uaArray.length;

      mtaLog.logs.push({
          type: 'business',
          tags: {
            method: method,
            nbType: 'mtnb-knb',
            app: ((uaArray[ualen - 2] +  uaArray[ualen - 1]) || '').toLowerCase(),
            path: location.protocol + '//' + location.hostname + location.pathname,
            ua: navigator.userAgent,
            msg: msg || ''
          }
      });

      var elementSrc = 'https://frep.meituan.com/api/collect?token=5788a4a2488076d81906aa66&empty=true&data=' +
          encodeURIComponent(JSON.stringify(mtaLog));
      element.setAttribute('src', elementSrc);
      document.body.appendChild(element);
      mtaLog.logs.pop();
    } catch (e) {
      noop();  // do nothing
    }
  };
  //采样率10%
  var sendLog = Math.random() < 0.1 ? report: noop;

  function getCookie (a) {
    var b = document.cookie.match("(?:;|^)\\s*" + a + "\\s*=\\s*([^;]+)\\s*(?:;|$)");
    return b && b[1];
  }

  var q = location.href.split('?')[1] || '';
  var qparams = {};
  q = q.split('&');
  for (var i = 0; i < q.length; i++) {
    var pair = q[i].split('=');
    qparams[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }

  function xhr (url, success) {
    try {
      var _xhr = new XMLHttpRequest();
      _xhr.open("GET", url, true);
      _xhr.onreadystatechange = function () {
        if (_xhr.readyState == 4) {
          _xhr.onreadystatechange = null;
          var data = JSON.parse(_xhr.responseText);
          if (data.status == 0) {
            success(data.data);
          }
        }
      };
      _xhr.send();
    } catch (e) {
      console.error(e);
    }
  }

 function getVersionInfo(name) {
   try {
     switch (name) {
       case "imeituan":
         return navigator.userAgent.match(/meituangroup\/?([^ ]+)/i)[1]; // android中间没/
       case "KNB":
         //修复android 7.7.0 多个KNB/x.x.x的bug :(
         return navigator.userAgent.match(/KNB\/(\S+)/g).map(function (str) {
              return str.match(/KNB\/([^ ]+)/i)[1];
         });
     }
   } catch (e) {
     noop(); // do nothing
   }
   return '0';
 }

  //////////// Fallback Method, with JavascriptWebviewBridge and imeituan schema
  var isInited = false;
  var biz = "default";
  var isAndroid =  (navigator.userAgent || '').match(/Android/i);
  var isIphone  =  (navigator.userAgent || '').match(/(iPhone|iPad|iPod)/i);
  var isMeituanAPP = /meituan/i.test(navigator.userAgent);
  var isMaoyan     = /movie/i.test(navigator.userAgent);

  var imeituanversion = getVersionInfo('imeituan');
  var mtnbNativeVersions = getVersionInfo('KNB');
  var canDetectInternalAPI = (mtnbNativeVersions == '0' ? [] : mtnbNativeVersions).some(function (version) { return parseFloat(version) >= 1.1; });

  function ready(callback) {
      function init (bridge) {
        if (isInited) return;
        try {
            bridge.init();
            isInited = true;
        } catch (e) {
          console.log('init failed');
        }
      }
      // 如果有WebViewJavascriptBridge这个全局变量，
      // 则直接初始化它
      if (window.WebViewJavascriptBridge) {
          init(WebViewJavascriptBridge);
          callback(WebViewJavascriptBridge);
          return;
      }

      // 否则添加监听事件再初始化
      document.addEventListener('WebViewJavascriptBridgeReady', function () {
        init(WebViewJavascriptBridge);
        callback(WebViewJavascriptBridge);
      }, false);
  }
  ////////////////

  var messageHandlers = {};
  var responseCallbacks = {};
  var uniqueId = 1;
  var blockedJob = [];
  var subHandleMap = {};
  var subEventMap = {};
  var uniqueSubId = 0;

  var useMTNB = navigator.userAgent.indexOf('MTNB') > -1 || navigator.userAgent.indexOf('KNB') > -1;
  var channelMap1 = {
    WECHAT_FRIENDS: 1,
    WECHAT_TIMELINE: 2,
    QQ: 4,
    SMS: 8,
    WEIBO: 16,
    QZONE: 32,
    EMAIL: 64,
    COPY: 128
  };
  var channelMap2 = {
    WECHAT_FRIENDS: 128,
    WECHAT_TIMELINE: 256,
    QQ: 512,
    SMS: 32,
    WEIBO: 1,
    QZONE: 2,
    // not supported
    EMAIL: 0,
    COPY: 0
  };

  function getChannels() {
    if (useMTNB && !isAndroid && !isMaoyan) {
      return channelMap1;
    }
    return channelMap2;
  }

  function send(message, responseCallback) {
    if (responseCallback) {
      var callbackId = 'cb_'+(uniqueId++)+'_'+new Date().getTime();
      responseCallbacks[callbackId] = responseCallback;
      message.callbackId = callbackId;
    }
    message.fromKNB = true;  // add formKNB mark for usage tracking
    var messageTxt = JSON.stringify(message);

    if (isIphone) _MTNB._handleMessageFromJs(messageTxt);
    if (isAndroid) window.prompt(messageTxt);
    log("Notice", "sending:", message);
  }

  function _handleMessageFromApp(message) {
    var responseCallback;

    if (!message || !isObject(message)) return log('error', 'message is not defined or is not a valid object');
    log("Notice", "get message:" , message); // do not stringify the message because of performance hit

    // 同步回调
    // 指的是一般性调用bridge
    if (message.callbackId) responseCallback = responseCallbacks[message.callbackId];

    // 异步回调
    // 指的是注册按钮的回调函数
    if (message.handlerId) {
      responseCallback = messageHandlers[message.handlerId];
      message.data = message.data || {status: 0};
    }

    // 每个模块的回调函数如果没有返回值，或返回值不为false，则出错，且向上给MTNB.onerror抛出错误
    // 回调MTNB.onerror
    var status = message.data && message.data.status;
    var ret = isFunction(responseCallback) && responseCallback(message.data);
    if (ret && (status !== 0) && isFunction(MTNB.onerror)) {
      MTNB.onerror(0, 'test error message', null);
    }
  }

  MTNB = {
    _INITED: false,
    callHandler: function callHandler(params, responseCallback, handlerMapper) {
      // params.data就是用户调用时传的数据
      // 如果是数组的话，就每个都format一遍
      [].concat(params.data).filter(Boolean).forEach(function (obj) {
        if (!isFunction(obj.handle)) return;
        // 把用户传进来的handle函数，转化为handleId，并将函数注册到messageHandlers下
        var handlerId = 'hd_' + (uniqueId++) + '_' + new Date().getTime();
        messageHandlers[handlerId] = function (params) {
          obj.handle((handlerMapper || valueFn)(params));
        };
        obj.handlerId = handlerId;
      });
      send( params, responseCallback);
    },
    apis: {},
    _handleMessageFromApp: _handleMessageFromApp,
    //注册一个协议, 其中obj的格式为：
    // {
    //   name: String
    //   moduleName: String,
    //   methodName: String,
    //   // 为与KNB接口兼容，需要三个维度上的参数映射
    //   mapper: Function,         // 对调用MTNB.call时参数的映射
    //   handlerMapper: Function,  // 对Native传给handler的参数的映射
    //   callbackMapper: Function, // 对Native传给callback参数的映射
    //
    //   handler: Function,        // 凡是定义了handler，表示可以不走NB协议
    //   fallback: Function,       // 在不支持MTNB时的fallback方案
    //
    // }
    reg: function (obj) {
      var name = obj.name;
      var statics = obj.statics;
      obj.businessName = obj.businessName || 'basic';
      MTNB[name] = function (params) {
        MTNB.call(name, params);
      };
      Object.keys(statics || {}).forEach(function (key) {
        MTNB[name][key] = obj.statics[key];
      });
      MTNB.apis[name] = obj;
      if (this._add) this._add(name, MTNB[name]); // reg method
    },
    //使用协议
    call: function (name, params) {
      if (MTNB._INITED == false && useMTNB) return blockedJob.push([name, params]);

      params = params || {};
      var obj = MTNB.apis[name];
      var par = ((obj && obj.mapper) || valueFn)(params);
      var businessName = 'basic';

      if (!name || typeof name !== 'string') return log('error', 'api name is invalid.');
      if (!obj && name.indexOf('.') > -1) {
        obj = parseName(name);
        businessName = obj.businessName;
      }
      if (!obj)                     return log('error', 'api name [' + name + '] is not implemented.');
      if (obj.handler)              return obj.handler(par);
      if (!useMTNB && obj.fallback) return obj.fallback(par);
      if (!useMTNB)                 return log('error', 'api [' + name + '] do not have a fallback.');

      var contextData = {
        "businessName": obj.businessName || businessName,
        "moduleName": obj.moduleName,
        "methodName": obj.methodName,
        "data": par
      };

      try {
        sendLog(businessName + '-' + obj.moduleName + '-' + obj.methodName);
      } catch (e) {
        // do nothing
        noop();
      }

      // 有这个逻辑是因为ios的处理缺陷, 部分api不能有callback传入, 否则会sb
      if ([
          'basic.webview.open',
          'basic.webview.close',
          'basic.webview.setIcon',
          'basic.webview.setTitle',
          'basic.webview.setHtmlTitle',
          'basic.account.login',
          'basic.account.logout'
        ].indexOf((businessName + "." + (obj.moduleName) + "." + (obj.methodName))) > -1) return MTNB.callHandler(contextData, null, obj.handlerMapper);

      MTNB.callHandler(contextData, function (res) {
        /**** [begin] please go to hell  ****/
        // android版本对basic.core.checkVersion返回的数据格式有问题
        if (
          businessName === 'basic' &&
          contextData.moduleName === 'core' &&
          contextData.methodName === 'checkVersion' &&
          typeof res.info === 'object'   // android return the wrong thing! wtf !
          ) return (par.success || noop)((obj.callbackMapper || valueFn)(res));
        /**** [end] please go to hell  ****/

        if (res.status != 0) return (params.fail || noop)(res);
        (par.success || noop)((obj.callbackMapper || valueFn)(res.data));
      }, obj.handlerMapper);
    }
  };

  MTNB.use = MTNB.call; // alias

  promisify(MTNB);

  /**
   * 用于检查一个全名的API是否被native支持。
   * 仅在MTNB大于1.1的版本适用.
   * 小于1.1的版本将直接返回false.
   */
  function isInternalSupported(fullName) {
    if (!canDetectInternalAPI) return Promise.resolve(false);
    return new Promise(function (resolve) {
      MTNB.checkVersion({
        apis: [fullName],
        success: function (data) {
          resolve(data.info && data.info[fullName] != 0);
        }
      });
    });
  }

  // register modules
  [{
    //config 配置KNB
    name: "config",
    handler: function (options) {
      if(options.debug != undefined) debug = options.debug;
      if(options.bizname != undefined) biz = options.bizname;
    }
  },
  {
    name: "ready",
    handler: function(cb) {
      if ( cb === void 0 ) cb=noop;

      sentinel.ready(cb);
    }
  },
  {
    name: "isApiSupported",
    handler: function (ref) {
      var apiName = ref.apiName;
      var success = ref.success; if ( success === void 0 ) success = noop;

      sentinel.ready(function () {
        var API = apiName.indexOf('.') > -1 ? parseName(apiName) : MTNB.apis[apiName];
        if (!API) return success(false);
        if (API.handler) return success(true);
        if (API.fallback && !useMTNB) return success(true);
        if (canDetectInternalAPI) return isInternalSupported(((API.businessName) + "." + (API.moduleName) + "." + (API.methodName))).then(success);
        success(true);
      });
    }
  },
  {
    name: 'getUA',
    handler: require('../common/get-ua')
  },
  {
    name: "share",
    moduleName: "share",
    methodName: "invoke",
    mapper: function (params) {
      return {
        url: params.url,
        title: params.title,
        pic: params.image,
        channel: sum(params.channel) || -1,
        content: params.desc,
        handle: params.success,
      };
    },
    statics: getChannels(),
    fallback: function (params) {
      var shareLink = "imeituan://www.meituan.com/share"
        + '?channel=' + (params.channel || -1)
        + "&title=" + encodeURIComponent(params.title)
        + "&imageURL=" + encodeURIComponent(params.pic)
        + "&detailURL=" + encodeURIComponent(params.url)
        + "&content_-1=" + encodeURIComponent(params.content)
        + "&content_1=" + encodeURIComponent(params.weiboContent);
      location.href = shareLink;
    }
  },
  {
    name: "openWebview",
    moduleName: "webview",
    methodName: "open",
    fallback: function (ref) {
      var url = ref.url; if ( url === void 0 ) url = '';

      if (isWebProtocol(url)) url = "imeituan://www.meituan.com/web?url=" + encodeURIComponent(url) ;
      location.href = url;
    }
  },
  {
    name: "closeWebview",
    moduleName: "webview",
    methodName: "close",
    fallback: function () {
      window.close();
    }
  },
  {
    name: "jumpWebview",
    handler: function (ref) {
      var url = ref.url; if ( url === void 0 ) url = "";

      if (isWebProtocol(url)) url = "imeituan://www.meituan.com/web?url=" + encodeURIComponent(url);

      if (isAndroid) {
        location.href = url;
        return MTNB.closeWebview();
      }  // Android没有支持closeAndNavigate..
      ready(function (bridge) {
        bridge.callHandler('callNativeMethod', {
          "moduleName" : "platform",
          "methodName" : "closeAndNavigate",
          "fromKNB"    : true,
          data : { "url" : url}
        }, noop);
      });
    }
  },
  {
    name: "setTitle",
    moduleName: "webview",
    methodName: "setHtmlTitle",
    fallback: function (params) {
      document.title = params.title;
    }
  },
  {
    name: "getLocation",
    moduleName: "geo",
    methodName: "getLocation",
    callbackMapper: function (param) {
      return {
        lat: param.latitude,
        lng: param.longitude
      };
    },
    fallback: function (params) {
      navigator.geolocation.getCurrentPosition(function (geo) {
        params.success && params.success({
          lat: geo.coords.latitude,
        lng: geo.coords.longitude
        });
      }, function (err) {
        params.fail && params.fail(err);
      }, {timeout: params.timeout, enableHighAccuracy: false});
    }
  },
  {
    name: "login",
    moduleName: "account",
    methodName: "login",
    mapper: function (params) {
      params.handle = function (res) {
        var success = (params.success || noop);
        var fail   = (params.fail || noop);
        // handle会返回userId等字段
        if (res.userId) {
          return success({
            type: 'mt',
            name: res.userName,
            userId: res.userId,
            token: res.userToken
          });
        }
        // 如果失败，会返回status字段不为0
        if (String(res.status) !== "0") return fail(res);
        // 否则，是callback风格的成功
        success(res.data);
      };
      return params;
    },
    fallback: function () {
      if (isMeituanAPP) {
        location.href = "imeituan://www.meituan.com/signin?redirectURL=" + encodeURIComponent(location.href);
        return;
      }
      // 如果不是meituan app，且没有mtnb，则跳转到i版页面
      location.href = "//i.meituan.com/account/login?backurl=" + encodeURIComponent(location.href);
    }
  },
  {
    name: "logout",
    moduleName: "account",
    methodName: "logout"
  },
  {
    name: "getCity",
    handler: function (params) {
      var cityId = parseInt(qparams.ci);
      if (!cityId) {
        cityId = parseInt(getCookie("cityid")) || 0;
      }
      params.success({
        cityId: cityId,
        type: 'mt'
      });
    }
  },
  {
    name: "getLocationCity",
    handler: function (params) {
      MTNB.getLocation({
        timeout: 1000,
        success: function (loc) {
            xhr("//i.meituan.com/locate/latlng/"+loc.lat+","+loc.lng+".json?ndr", function(data) {
              params.success && params.success({
              cityId: data.id,
              type: 'mt'
            });
          });
        },
        fail: params.fail
      });
    }
  },
  {
    name: "store",
    handler: function (params) {
      var key;
      try {
        if (params.key.indexOf(':') != -1) {
          key = params.key;
        } else {
          key = biz + ":" + params.key;
        }
        localStorage[key] = params.value;
        params.success && params.success();
      } catch (e) {
        params.fail && params.fail(e);
      }
    }
  },
  {
    name: "retrieve",
    handler: function (ref) {
      var key = ref.key; if ( key === void 0 ) key = '';
      var success = ref.success; if ( success === void 0 ) success = noop;
      var fail = ref.fail; if ( fail === void 0 ) fail = noop;

      var value;
      try {
        value = localStorage[key.indexOf(':') != -1 ? key : (biz + ":" + key)];
      } catch (e) {
        return fail(e);
      }
      success({value: value});
    }
  },
	{
		name: 'lxlog',
		businessName: 'mtalog',
		moduleName: 'stat',
		methodName: 'log'
	},
  {
    name: "getNetworkType",
    handler: function (ref) {
      var success = ref.success; if ( success === void 0 ) success = noop;

      var network = getCookie('network');
      success({
        networkType: network
      });
    }
  },
  ].forEach(MTNB.reg.bind(MTNB));

  // 从可以检测native API版本开始
  if (canDetectInternalAPI) {
    [{
      name: "checkVersion",
      moduleName: "core",
      methodName: "checkVersion"
    },
    {
      name: 'uploadImage',
      moduleName: 'media',
      methodName: 'uploadImage',
      mapper: function (_opts) {
        var opts = mixin({}, _opts);

        if (!_opts.clientId) {
          opts.clientId = opts.bucket;
        }
        return opts;
      },
      callbackMapper: function (ref){
        var photoInfos = ref.photoInfos; if ( photoInfos === void 0 ) photoInfos = [];

        return {
          photoInfos: photoInfos.map(function (photo) {
            var picKey = photo.picKey;
            var httpsKey = picConverter(photo.picKey);
            return mixin(photo, {picUrl: httpsKey, picKey:httpsKey, originalKey: picKey})
          })
        }
      }
    },
    {
      name: 'previewImage',
      moduleName: 'media',
      methodName: 'previewImage'
    },
    {
      name: 'publish',
      moduleName: 'message',
      methodName: 'publish',
      mapper: function (params) {
        //mtnb 文档实现有误,导致native实现的时候用的info.而点评是传的data
        params.info = params.info || params.data;
        return params;
      }
    },
    {
      name: 'subscribe',
      handler: function (ref) {
        var action = ref.action;
        var handle = ref.handle; if ( handle === void 0 ) handle = noop;
        var success = ref.success; if ( success === void 0 ) success = noop;
        var fail = ref.fail; if ( fail === void 0 ) fail = noop;

        if (!action) return;
        var eventName = action;
        var eventQueue = subEventMap[eventName] || [];

        var subId = 'sub_' + (++uniqueSubId);
        subHandleMap[subId] = handle;

        if (eventQueue.length) {
          eventQueue.push(subId);
          subEventMap[eventName] = eventQueue;
          return success({subId: subId});
        }

        eventQueue.push(subId);
        subEventMap[eventName] = eventQueue;
        var handleQueue = function (e) {
          (subEventMap[eventName] || []).forEach(function (subId) { return subHandleMap[subId](e); })
        };

        MTNB.use('basic.message.subscribe',{
          action: eventName,
          handle: handleQueue,
          success: function () { return success({subId: subId}); },
          fail: fail
        });
      }
    },
    {
      name: 'unsubscribe',
      handler: function (ref) {
        var action = ref.action;
        var subId = ref.subId;
        var success = ref.success; if ( success === void 0 ) success = noop;

        if (subId) {
          subHandleMap[subId] = noop;
        } else if (action) {
          subEventMap[action] = [];
        }
        success();
      }
    },
    {
      name: 'setNavigationBarHidden',
      moduleName: 'webview',
      methodName: 'setNavigationBarHidden'
    },
    {
      name: 'setBackgroundColor',
      moduleName: 'webview',
      methodName: 'setBackgroundColor'
    },
    {
      name: 'setBouncesEnabled',
      moduleName: 'webview',
      methodName: 'setBouncesEnabled'
    },
    {
      name: 'setStatusBarStyle',
      moduleName: 'webview',
      methodName: 'setStatusBarStyle'
    },
      //ios和android对确认和取消按钮的处理均存在错误
      /*
      {
        name: 'alert',
        moduleName: 'system',
        methodName: 'alert'
      },
      {
        name: 'confirm',
        moduleName: 'system',
        methodName: 'confirm'
      },
      {
        name: 'prompt',
        moduleName: 'system',
        methodName: 'prompt'
      },*/
    {
      name: 'sendSMS',
      moduleName: 'system',
      methodName: 'sendSMS'
    },
    {
      name: 'getContactList',
      moduleName: 'system',
      methodName: 'getContactList'
    },
  /*{
      name: 'downloadImage',
      moduleName: 'media',
      methodName: 'downloadImage'
    },*/
    {
      name: "chooseImage",
      moduleName: "media",
      methodName: "chooseImage"
    }].forEach(MTNB.reg.bind(MTNB));
  }

  // 为防止ios crash，从7.1开始支持.
  if (imeituanversion !== '0' && imeituanversion.indexOf('7.0') === -1) {
    MTNB.reg({
      name: "chooseImage",
      moduleName: "media",
      methodName: "chooseImage"
    });
  }

  // 因为设置按钮每一次都需要全量设置
  // 所以需要缓存
  var icons = {
    l: null,
    r: null
  };
  MTNB.reg({
    name: "setNavButtons",
    moduleName: "webview",
    methodName: "setIcon",
    mapper: function (params) {
      params = [].concat(params).filter(Boolean);
      for (var i = 0; i < params.length; i++) {
        var icon = params[i];
        if (icon.type == "base64") icon.url = icon.icon; // for android
        // 只处理RL/RR，是因为MTNB不支持对LL/LR按钮的配置
        if (icon.position == "RL") icons.l   = icon.disable ? null : icon;
        if (icon.position == "RR") icons.r   = icon.disable ? null : icon;
      }
      return [icons.l, icons.r].filter(Boolean);
    }
  });

  MTNB.reg({
    name: "configShare",
    handler: function (params) {
      // KNB on Android
      if (useMTNB && isAndroid) {
        return MTNB.setNavButtons({
          type: "base64",
          position: "RR",
          icon: window._MTNB_DEFAULT_SHARE_ICON || "data:image/png;base64,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",
          handle: function () {
            params.handle && params.handle();
            MTNB.share(params);
          }
        });
      }
      // KNB on iOS
      if (useMTNB && !isAndroid) {
        return MTNB.setNavButtons({
          type: 'share',
          position: 'RR',
          handle:function() {
            params.handle && params.handle();
            MTNB.share(params);
          }
        });
      }

      // waimai c端
      ready(function (bridge) {
        // 这个bridge方法是用来设置右上角button的。
        bridge.callHandler('callNativeMethod', {
          "moduleName": "platform",
          "methodName": "shareCommon",
          "fromKNB"    : true,
          "data": {
            "channel": sum(params.channel)+"", //外卖bug，channel必须是字符串
            "content": params.content,
            "content_-1": params.content,
            "content_1": params.weiboContent || params.content,
            "detailURL": params.url,
            "imageURL": params.image,
            "title": params.title
          }
        }, function (res) {
          params.success && params.success(res);
        });
      });
    }
  });

  var stopHandler = noop;

  function jsbSetPullDownReg() {
    if (imeituanversion == '0') return; // only register on metiuangroup app
    MTNB.reg({
      name: "setPullDown",
      handler: function (params) {
        ready(function(bridge) {
          bridge.callHandler('callNativeMethod', {
            moduleName : 'platform',
            methodName : 'buildUpRefresh',
            fromKNB: true,
            data: { partial: true }
          }, noop);
          bridge.registerHandler("pullToRefresh", function (data, callback) {
            stopHandler = callback;
            params.handle();
          });
        });
      }
    });
  }

  function jsbStopPullDownReg() {
    if (imeituanversion == '0') return;
    MTNB.reg({
      name: "stopPullDown",
      // `stopHandler` is a variable, don't assign it directly here.
      // it might change by time.
      handler: function () { return stopHandler(); }
    });
  }

  [{
    name: 'setPullDown',
    businessName: 'basic',
    moduleName: 'webview',
    methodName: 'setPullDown',
    fallbackRegFn: jsbSetPullDownReg,
  },{
    name: 'stopPullDown',
    businessName: 'basic',
    moduleName: 'webview',
    methodName: 'stopPullDown',
    fallbackRegFn: jsbStopPullDownReg,
  },{
    name: 'setSearchBar',
    businessName: 'meituan',
    moduleName: 'webview',
    methodName: 'setSearchBar',
    fallbackRegFn: function () {
      MTNB.reg({
        name: 'setSearchBar',
        handler: function (props) {
            ready(function (bridge) {
              bridge.callHandler('callNativeMethod', {
                'moduleName' : 'platform',
                'methodName' : 'search',
                'fromKNB'    : true,
                data : props  // isShowSearch / searchText / searchTextColor / searchCateId
              }, noop);
            })
        }
      });
    },
  },{
    name: 'setLLButton',
    businessName: 'basic',
    moduleName: 'webview',
    methodName: 'setLLButton',
    fallbackRegFn: noop
  },{
    name: 'getUserInfo',
    businessName: 'basic',
    moduleName: 'account',
    methodName: 'getUserInfo',
    callbackMapper: function (ret) {
      return mixin(ret,{
        userId: +ret.userId || +ret.id,
        token: ret.token || qparams['token'],
        uuid: ret.uuid || qparams['uuid']
      })
    },
    fallbackRegFn: function () {
      MTNB.reg({
        name: 'getUserInfo',
        handler: function (ref) {
            var success = ref.success; if ( success === void 0 ) success = noop;

            success({
              type: 'mt',
              userId: qparams['userid'] ? parseInt(qparams['userid']) : null,
              uuid: qparams['uuid'] ? qparams['uuid'] : null,
              token: qparams['token'] ? qparams['token'] : null
            });
          }
      })
    }
  }].forEach(function (ref) {
    var name = ref.name;
    var businessName = ref.businessName;
    var moduleName = ref.moduleName;
    var methodName = ref.methodName;
    var fallbackRegFn = ref.fallbackRegFn;
    var callbackMapper = ref.callbackMapper;

    sentinel.increase();
    isInternalSupported((businessName + "." + moduleName + "." + methodName)).then(function (supported) {
      sentinel.decrease();
      if (!supported) return fallbackRegFn();
      MTNB.reg({name: name, businessName: businessName, moduleName: moduleName, methodName: methodName, callbackMapper: callbackMapper});
    });
  });

  // 如果没有imeituanversion信息，则是6.x及以下版本
  // Android没有实现MTNB版的fingerprint
  // WHAT A PILE OF HOLY SHIT!!
  MTNB.reg(function() {
    if (useMTNB && imeituanversion !== '0' && !isAndroid) {
      return {
        name: "getFingerprint",
        moduleName: "fingerprint",
        methodName: "getFingerprint"
      };
    }
    return {
      name: "getFingerprint",
      handler: function (params) {
        ready(function (bridge) {
          bridge.callHandler('conveyFingerPrintInfoHandler', {
            "fromKNB": true
          }, function (res) {
            params.success && params.success(res);
          });
        });
      }
    };
  }());

  sentinel.tryResolve(); // try resolve first

  MTNB.__version__ = version;

  // 被引用统计
  logEvent('mtnb', MTNB.__version__);

  if (isBrowser) window.MTNB = MTNB;

  module.exports = MTNB;

  if (!useMTNB) return;

  // init MTNB
  window.dpMTNBInit = function(data) {
    if (!data.nonceStr) return report('mtnb-init-failed', 'nonceStr not exist'); // avoid call native to prevent crash under iOS Group 6.5
    MTNB.callHandler({
      "businessName": "basic",
      "moduleName": "core",
      "methodName": "init",
      "data": {
        "nonceStr": data.nonceStr,
        "ts": parseInt(data.ts) || 0,
        "url": data.url,
        "sign": data.sign
      }
    }, function (res) {
      initCallback(res);
      if (res && res.status !== 0) {
        var resString = JSON.stringify(res);
        report('mtnb-init-failed', resString);
        log('error', resString);
        return;
      }

      MTNB._INITED = true;
      for (var i = 0; i < blockedJob.length; i++)  MTNB.call(blockedJob[i][0], blockedJob[i][1]);
    });
  };
  var script = document.createElement('script');
  script.setAttribute('type', 'text/javascript');
  var url = location.protocol + '//m.dianping.com/mtnb/api/signature?callback=dpMTNBInit';
  script.setAttribute('src', url);
  document.getElementsByTagName('head')[0].appendChild(script);
})();



// WEBPACK FOOTER //
// ./~/@dp/knb/compiled/mtnb/index.js